var voted_users_rtlignore_default = {
  "container": "_3lUdJ",
  "webview": "LwqcQ",
  "avatar_list": "yf-Mu",
  "avatar": "_9PUQe",
  "user_avatar": "Nj47b",
  "modal": "v-73J",
  "voted_users_modal": "qmBfV",
  "overlay": "_9ovqk",
  "user_card": "hvkb3",
  "user_name": "Hugmm",
  "voted_users_modal_header": "OGne3",
  "cta": "LJ3KG",
  "close_icon": "lV2mW",
  "title": "IW5bZ",
  "member_list_container": "dKD7t",
  "member_list": "_6IG8B",
  "loader": "XARG0",
  "anonymous_counter": "g6nLQ",
  "spinner": "Nsg-V",
  "spin": "Z-iP1"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
